var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      attrs: {
        size: "960px",
        "append-to-body": true,
        title: _vm.$t("biz_te_choose_teach" /*选择讲师*/),
        visible: _vm.visible,
        "destroy-on-close": "",
        "before-close": _vm.hasChange,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        closed: _vm.closed,
      },
    },
    [
      _c("yxtbiz-teacher-selector", {
        attrs: {
          allowSelectUser: _vm.allowSelectUser,
          singleMode: _vm.singleMode,
          type: _vm.teacherType,
          newReq: _vm.newReq,
          prepared: _vm.prepared,
        },
        on: { select: _vm.selectUser },
        model: {
          value: _vm.users,
          callback: function ($$v) {
            _vm.users = $$v
          },
          expression: "users",
        },
      }),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "yxt-button",
            { attrs: { plain: "" }, on: { click: _vm.closed } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("pc_comp_drawer_cancel" /* 取消 */)) +
                  "\n    "
              ),
            ]
          ),
          _c(
            "yxt-button",
            { attrs: { type: "primary" }, on: { click: _vm.save } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("pc_comp_drawer_confirm" /* 确定 */)) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }